<div class="wrapper">
  <input
    #input
    [autocomplete]="autocomplete"
    [type]="type"
    [id]="uniqueId"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngClass]="[variant]"
    [value]="value"
    (input)="onChange($event.target.value)"
    (focus)="focused()"
    (blur)="blurred()"
    (keyup)="valueChanged($event.target.value)"
  />

  <div class="actions">
    <studio-button-legacy
      theme="borderless"
      (click)="togglePasswordVisibility()"
      *ngIf="toggleIsVisible && !disabled"
    >
      <studio-icon [name]="iconName" size="22"></studio-icon>
    </studio-button-legacy>
  </div>
</div>
